module.exports = __webpack_public_path__ + "img/daily_necessities_etc.4a321708.jpg";